import React, { FC, useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Select } from "antd";
import { ReactSVG } from "react-svg";
import { SwapOutlined, ShareAltOutlined } from "@ant-design/icons";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { SET_CURRENT_PROJECT } from "reducers/reducer";
import CPCModal from "./CpcModal";
import Geocode from "react-geocode";
import ShareDispatchUrlModal from "./ShareDispatchUrlModal";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from "@fullcalendar/rrule";
import useSocketActions from "../../../../hooks/socketActions";
import { getCalendarSettingsPath } from "../../../../hooks/socketConstants";
import { LoadingOutlined, CheckOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { UserTopics, CalendarTopics } from "constants/enums";
import { Input } from "antd";
import { GET_AGGREGATE, DECRYPT_TOKEN } from "../../../../reducers/reducer";
import { formatForRedis } from "utils/appUtil";
import { throttle, debounce } from "throttle-debounce";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

let customerSearchTimeout;

const DispatchPanel: FC<{ socket: ISocket; params: any }> = ({
  socket,
  params,
}) => {
  const [nine11Form] = Form.useForm();
  // const [userError, setUserError] = useState<string>("");
  // const [projectError, setProjectError] = useState<string>("");
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const { search } = useLocation();
  const history = useHistory();
  const projects = useSelector(
    (state: RootState) => state.auth.projects,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  const dispatch = useDispatch();
  const calendarRef = useRef(null);
  const [events, setEvents] = useState<any>(
    // JSON.parse(localStorage.getItem("events") || "[]")
    []
  );
  const [pages, setPages] = useState<any>([]);
  const [uploadModalVisible, setUploadModalVisible] = useState<any>();
  const { getUserRequestPayload } = useSocketActions();
  const [calendarSettings, setCalendarSettings] = useState<any>();
  const [selectedCalendarSetting, setSelectedCalendarSetting] = useState<any>();
  const [selectedProjectId, setSelectedProjectId] = useState<any>();
  const [selectedCustomerId, setSelectedCustomerId] = useState<any>();
  const [customerLoading, setCustomerLoading] = useState<boolean>(false);
  const [validRange, setValidRange] = useState<any>({ start: new Date() });
  const [slotDuration, setSlotDuration] = useState<any>("00:30:00");
  const [hiddenDays, setHiddenDays] = useState<any>([]);
  const [calendarView, setCalendarView] = useState<any>("dayGridMonth");
  const [isShareModalVisible, setIsShareModalVisible] =
    useState<boolean>(false);
  const { encrypted_token } = useSelector((state: RootState) => state.auth);

  const onProjectChange = (projectId) => {
    dispatch({ type: SET_CURRENT_PROJECT, payload: projectId });
    const selectedProject = projects?.projects?.find((x) => {
      return x.id === projectId;
    });
    console.log("selected project", selectedProject);
    setSelectedProjectId(projectId);
    const selectedCalendarSettings = Object.keys(
      calendarSettings || {}
    )?.filter((calendarId) => {
      return selectedProject?.calendarIds?.indexOf(calendarId) !== -1;
    });
    console.log("selected calenda", selectedCalendarSettings);
    setSelectedCalendarSetting(selectedCalendarSettings);
  };

  const minutesToHHMMSS = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const hoursStr = hours.toString().padStart(2, "0");
    const minutesStr = remainingMinutes.toString().padStart(2, "0");
    const secondsStr = "00";

    return `${hoursStr}:${minutesStr}:${secondsStr}`;
  };

  useEffect(() => {
    if (selectedCalendarSetting && selectedCalendarSetting.length > 0) {
      const setting = calendarSettings?.[selectedCalendarSetting[0]];

      console.log("control calendar here", setting);

      setValidRange({
        start: new Date(),
        end: new Date(setting?.validityRange?.[1]),
      });

      setSlotDuration(minutesToHHMMSS(setting?.appointmentDuration));

      const allDays = [
        { name: "monday", day: 1 },
        { name: "tuesday", day: 2 },
        { name: "wednesday", day: 3 },
        { name: "thursday", day: 4 },
        { name: "friday", day: 5 },
        { name: "saturday", day: 6 },
        { name: "sunday", day: 0 },
      ];
      const hiddenDays = [];
      let allowedDays = [];
      setting?.operationConfig.map((config) => {
        allowedDays = [...allowedDays, ...config.daysOfTheWeek];
      });
      allDays.map((day) => {
        if (allowedDays?.indexOf(day.name) === -1) {
          hiddenDays.push(day.day);
        }
      });
      console.log("hidden days", hiddenDays);
      setHiddenDays(hiddenDays);
      setEvents([]);

      if (calendarRef.current) {
        const selectedDate = calendarRef.current
          .getApi()
          .changeView("dayGridMonth");
      }
    }
  }, [selectedCalendarSetting]);

  useEffect(() => {
    if (socket.client) {
      const query = new URLSearchParams(search);
      const userId = query.get("userId");
      const connectionId = query.get("connectionId");
      const projectId = query.get("projectId");
      const token = query.get("token");
      if (token) {
        dispatch(
          DECRYPT_TOKEN({
            data: { payload: token },
            callback: (data) => {},
          })
        );
      } else {
        dispatch({
          type: "ADD_ENCRYPTED_TOKEN",
          payload: {
            connectionId,
            userId,
            projectId,
          },
        });
      }
    }
  }, [search, socket.client]);

  useEffect(() => {
    if (encrypted_token) {
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
          cudbServiceId: encrypted_token?.cudbServiceId,
        })
      );
    }
  }, [encrypted_token]);

  useEffect(() => {
    if (projects?.userServiceId) {
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.SearchInUser,
        getUserRequestPayload(
          projects?.adminUserId,
          "$",
          getCalendarSettingsPath()
        ),
        CalendarTopics.GetCalendarSetting,
        projects?.userServiceId
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        CalendarTopics.GetCalendarSetting,
        (resp) => {
          console.log("calendar settings", resp?.data?.[0]?.[0]);
          setCalendarSettings(resp?.data?.[0]?.[0]);
        }
      );
    }
  }, [projects]);

  function renderEventContent(eventInfo) {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
      </>
    );
  }

  const handleDateSelect = (selectInfo: any) => {
    let calendarApi = selectInfo.view.calendar;
    if (selectInfo.view.type === "dayGridMonth") {
      calendarApi.changeView("timeGridDay");
      calendarApi.gotoDate(selectInfo.startStr);
    } else if (selectedProjectId && selectedCustomerId) {
      calendarApi.unselect();
      setUploadModalVisible(selectInfo);
    } else {
      nine11Form.submit();
      // setError("**Required information missing")
    }
  };

  const handleViewChange = (viewInfo) => {
    // Handle the view change event here
    // console.log("View changed to:", viewInfo.view.currentStart);
    if (calendarRef.current) {
      const selectedDate = calendarRef.current.getApi().getDate();
      console.log("Selected date:", selectedDate.toISOString());
    }
    setCalendarView(viewInfo.view.type);
  };

  const generateAvailableSlots = (date, intervalInMinutes) => {
    const availableSlots = [];
    const currentDate = new Date(date);
    // Calculate the start of the day (midnight)
    const startOfDay = new Date(currentDate);
    startOfDay.setHours(0, 0, 0, 0);
    // Calculate the end of the day (11:59:59 PM)
    const endOfDay = new Date(currentDate);
    endOfDay.setHours(23, 59, 59, 999);
    // Convert the date objects to string representations
    const startTime = startOfDay.getTime();
    const endTime = endOfDay.getTime();
    const interval = intervalInMinutes * 60 * 1000; // 15 minutes in milliseconds
    for (let current = startTime; current < endTime; current += interval) {
      availableSlots.push({
        startTime: current,
        endTime: current + interval,
      });
    }
    return availableSlots;
  };

  const subtractAllowedSlots = (availableSlots, allowedSlots) => {
    const unavailableSlots = [];
    for (const slot of availableSlots) {
      let isSlotAvailable = true;
      for (const allowedSlot of allowedSlots) {
        if (
          slot.startTime >= allowedSlot.startTime &&
          slot.endTime <= allowedSlot.endTime
        ) {
          isSlotAvailable = false;
          break;
        }
      }
      if (isSlotAvailable) {
        unavailableSlots.push(slot);
      }
    }

    return unavailableSlots;
  };

  const setTimeFromDate = (targetDate, sourceDate) => {
    targetDate.setHours(sourceDate.getHours());
    targetDate.setMinutes(sourceDate.getMinutes());
    targetDate.setSeconds(0);
    targetDate.setMilliseconds(0);
    return targetDate;
  };

  const handleDateChange = (arg) => {
    // Handle the date change event here
    const start = arg.startStr;
    console.log("Date changed. Start date:", start);

    const setting = calendarSettings?.[selectedCalendarSetting?.[0]];

    if (setting) {
      if (selectedProjectId && setting.noOfPeople === 1) {
        getPagesthrottleFunc(start, setting.appointmentDuration);
      }

      const dayNames = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];

      const selectedOperationConfig = setting.operationConfig.find((x) => {
        return (
          x.daysOfTheWeek.indexOf(dayNames?.[new Date(start).getDay()]) !== -1
        );
      });

      console.log("selected operation config", selectedOperationConfig);

      if (!selectedOperationConfig) {
        return;
      }

      const allowedSlots = selectedOperationConfig?.operationHours?.map((x) => {
        const startDate = setTimeFromDate(
          new Date(start),
          new Date(x.startTime)
        );
        const endDate = setTimeFromDate(new Date(start), new Date(x.endTime));
        return {
          startTime: startDate.getTime(),
          endTime: endDate.getTime(),
        };
      });

      const availableSlots = generateAvailableSlots(
        start,
        setting.appointmentDuration
      );

      console.log("availebe slots", availableSlots);

      const unavailableSlots = subtractAllowedSlots(
        availableSlots,
        allowedSlots
      );

      const unavailableEvents = unavailableSlots.map((slot) => ({
        title: "Unavailable",
        start: new Date(slot.startTime),
        end: new Date(slot.endTime),
        rendering: "background", // Renders as background to block the slot
        color: "lightgray", // Customize the color for disabled slots
      }));

      console.log("un availabe events", unavailableEvents);

      setEvents(unavailableEvents);
    }
  };

  const getCustomer = (customerId) => {
    if (customerSearchTimeout) clearTimeout(customerSearchTimeout);
    setCustomerLoading(true);
    customerSearchTimeout = setTimeout(() => {
      const customerRequest: any = {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:custom:id`,
            // searchIndex: "beamdev:custom:id",
            searchQuery: `@partitions:{'org\\:${formatForRedis(
              projects?.userServiceId
            )}'}`,
            searchOptions: "VERBATIM TIMEOUT 10000",
          },
          load: {
            info: "$.info",
            id: "$.info.id",
            objectId: "$.objectId",
          },
        },
        filter: {
          expression: `exists(@id) && @id==='${customerId}'`,
        },
      };
      dispatch(
        GET_AGGREGATE({
          requestData: customerRequest,
          callback: (response) => {
            setCustomerLoading(false);
            const customer = response?.[0];
            if (customer) {
              console.log("customer response", customer);
              setSelectedCustomerId(customer.id);
            } else {
              setSelectedCustomerId(undefined);
            }
          },
        })
      );
    }, 500);
  };

  const getPagesthrottleFunc = useCallback(
    debounce(
      500,
      (date, duration) => {
        console.log("debounce");
        // Some API call
        searchPages(date, duration);
      },
      { atBegin: false }
    ),
    [selectedProjectId]
  );

  const searchPages = (date, duration) => {
    // const query = new URLSearchParams(search);
    // const userId = query.get("userId");

    const currentDate = new Date(date);
    const startOfDay = new Date(currentDate);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(currentDate);
    endOfDay.setHours(23, 59, 59, 999);
    const expressions = [
      "exists(@type)",
      "@type==='event'",
      `exists(@createdAt) && @createdAt > ${startOfDay.getTime()} && @createdAt < ${endOfDay.getTime()}`,
      `@iotAssetConfigId === '${selectedProjectId}'`,
    ];
    const getPagesRequest = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
          searchQuery: `@pageMembers:{'${projects?.adminUserId}'}`,
          searchOptions: "VERBATIM TIMEOUT 10000",
        },
        load: {
          pageId: "$.objectId",
          type: "$.persistent.static.metadata.type",
          createdAt: "$.persistent.static.metadata.createdAt",
          iotAssetConfigId:
            "$.persistent.static.iotAsset.config.iotAssetConfigId",
        },
      },
      filter: {
        expression: expressions.join("&&"),
      },
      sortBy: {
        properties: [],
        max: 1000,
      },
      result: {},
    };

    console.log("page request", getPagesRequest);

    dispatch(
      GET_AGGREGATE({
        requestData: getPagesRequest,
        callback: (response) => {
          console.log("page resppnse", response);
          const tempPages = response?.map((x) => {
            return {
              title: "Booked",
              start: new Date(x.createdAt),
              end: new Date(x.createdAt + duration * 60 * 1000),
            };
          });
          setPages(tempPages);
        },
      })
    );
    // getPageStatus();
  };

  return (
    <div className="main-column ride-dispatch-panel mobile-responsive mr-4">
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          initialValues={{}}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={(values) => {}}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            // localStorage.setItem("form", JSON.stringify(allValues));
          }}
        >
          <div className="main-header">
            <div className="d-flex">
              <h3 className="ml-3">Calendar</h3>
            </div>
            <div className="d-flex">
              {encrypted_token && !encrypted_token?.guest && (
                <ShareAltOutlined
                  style={{
                    color: "#869cbd",
                    fontSize: 21,
                    cursor: "pointer",
                    marginRight: 10,
                  }}
                  onClick={() => {
                    setIsShareModalVisible(true);
                  }}
                />
              )}

              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => {}}
              />
            </div>
          </div>

          <Row className="mt-3">
            <Col span={24}>
              <Form.Item
                name="customer"
                rules={[
                  {
                    message: "**Required Field",
                    validator: async (_, value) => {
                      console.log("val", _, value);
                      if (!value || value === "") {
                        return Promise.reject("**Required Field");
                      }
                      // Promise.resolve()
                    },
                  },
                ]}
              >
                <Input
                  placeholder={"Enter user id"}
                  name="customer"
                  onChange={(e) => {
                    getCustomer(e.target.value);
                  }}
                />
              </Form.Item>

              {customerLoading && (
                <Spin
                  indicator={antIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 15,
                  }}
                />
              )}
              {!customerLoading && selectedCustomerId && (
                <CheckOutlined
                  style={{
                    fontSize: 24,
                    color: "#40CC52",
                    position: "absolute",
                    top: 10,
                    right: 15,
                  }}
                />
              )}
            </Col>

            <Col span={24} className="mt-3">
              <Form.Item
                name="project"
                rules={[{ required: true, message: "**Required Field" }]}
              >
                <Select
                  showSearch
                  className="w-full"
                  placeholder="Select project"
                  onChange={(value) => {
                    onProjectChange(value);
                  }}
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {projects?.projects?.map((project, index) => (
                    <Select.Option value={project.id}>
                      {project.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col span={24}>
              <div className="tiles padding-12">
                <span className="col-label mb-3">
                  Select appointment date & time on calendar
                </span>
                <div className="mt-3">
                  <FullCalendar
                    plugins={[
                      rrulePlugin,
                      dayGridPlugin,
                      timeGridPlugin,
                      interactionPlugin,
                    ]}
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView="dayGridMonth"
                    validRange={validRange}
                    slotDuration={slotDuration}
                    hiddenDays={hiddenDays}
                    ref={calendarRef}
                    // slotLaneDidMount={handleSlotLaneDidMount}
                    // eventDisplay="block"
                    selectOverlap={false}
                    viewDidMount={handleViewChange}
                    editable={true}
                    selectable={true}
                    dayMaxEvents={false}
                    weekends={true}
                    events={
                      calendarView === "timeGridDay"
                        ? [...events, ...pages]
                        : []
                    }
                    select={handleDateSelect}
                    eventContent={renderEventContent}
                    datesSet={handleDateChange}
                  />
                </div>
              </div>
            </Col>
          </Row>

          {uploadModalVisible?.start && (
            <CPCModal
              socket={socket}
              start={uploadModalVisible?.start}
              selectedCustomerId={selectedCustomerId}
              selectedProjectId={selectedProjectId}
              onEventCreated={(event) => {
                const title = event?.["undefined"]?.userId;
                if (title) {
                  const tempEvents = [
                    ...events,
                    {
                      id: new Date().getTime().toString(),
                      title,
                      start: uploadModalVisible.startStr,
                      end: uploadModalVisible.endStr,
                      allDay: uploadModalVisible.allDay,
                    },
                  ];
                  // localStorage.setItem("events", JSON.stringify(tempEvents));
                  setEvents(tempEvents);
                }
                setUploadModalVisible(undefined);
              }}
              onClose={() => {
                setUploadModalVisible(undefined);
              }}
            />
          )}
        </Form>
      </div>

      {isShareModalVisible && (
        <ShareDispatchUrlModal
          onClose={() => {
            setIsShareModalVisible(false);
          }}
          socket={socket}
        />
      )}
    </div>
  );
};

export default DispatchPanel;
